var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "client-profiles-page",
      attrs: { id: "single-client-profile-page" },
    },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 form-page px-md-5 client pb-5" },
            [
              _c("client-profile-header", {
                attrs: {
                  back: _vm.back,
                  "board-id": _vm.boardIdToUse,
                  "client-profile-id": _vm.clientProfileId,
                  profile: _vm.profile,
                  saving: _vm.saving,
                  loading: _vm.loading,
                  "silent-loading": _vm.silentLoading,
                },
                on: {
                  changelog: _vm.loadChangelog,
                  "show-duplicate-modal": _vm.showDuplicateProfileModal,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-2" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("states-bar", {
                      attrs: {
                        "client-profile-id": _vm.clientProfileId,
                        progress: true,
                        loading: _vm.loading,
                        states: _vm.states,
                      },
                      on: { change: _vm.handleSave },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4" }, [
                _c(
                  "div",
                  { staticClass: "col-lg col-12 client-profile-sidebar" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _vm.starredApplication
                        ? _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("starred-linked-application", {
                                attrs: {
                                  application: _vm.starredApplication,
                                  "client-profile-id": _vm.clientProfileId,
                                },
                                on: {
                                  save: _vm.handleSave,
                                  "handle-referrer": _vm.handleReferrers,
                                  "copy-application": _vm.handleCopyApplication,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("client-profile-details", {
                            attrs: {
                              loading: _vm.loading,
                              "client-profile-id": _vm.clientProfileId,
                              profile: _vm.profile,
                              "board-id": _vm.boardIdToUse,
                              referrers: _vm.referrerValues,
                            },
                            on: {
                              save: _vm.handleSave,
                              "handle-referrer": _vm.handleReferrers,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("custom-fields", {
                            attrs: {
                              loading: _vm.loadingCustomFields,
                              "client-profile-id": _vm.clientProfileId,
                              profile: _vm.profile,
                              "board-id": _vm.boardIdToUse,
                            },
                            on: { save: _vm.handleSave },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("participants", {
                            attrs: {
                              "client-profile-id": _vm.clientProfileId,
                              "board-id": _vm.boardIdToUse,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("co-applicants-info", {
                            attrs: {
                              loading: _vm.loading,
                              profile: _vm.profile,
                              "client-profile-id": _vm.clientProfileId,
                            },
                            on: { save: _vm.handleSave },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("notified-referrers", {
                            attrs: {
                              "client-profile-id": _vm.clientProfileId,
                              profile: _vm.profile,
                              loading: _vm.loading,
                              referrers: _vm.referrerValues,
                            },
                            on: {
                              "handle-referrer": _vm.handleReferrers,
                              "change-referrer": _vm.loadChangelog,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("copy-application-modal", {
                            attrs: {
                              "application-street": _vm.applicationStreet,
                              "current-address-length":
                                _vm.currentAddressObjLength,
                              "document-count": _vm.documentCount,
                            },
                            on: { "copy-application": _vm.copyApplication },
                          }),
                          _vm._v(" "),
                          _c("linked-applications", {
                            attrs: {
                              "client-profile-id": _vm.clientProfileId,
                              applications: _vm.applications,
                              username: _vm.username,
                              profile: _vm.profile,
                            },
                            on: {
                              save: _vm.handleSave,
                              change: _vm.loadChangelog,
                              "duplicate-modal-opened":
                                _vm.setDuplicateProfileModalData,
                              "copy-application": _vm.handleCopyApplication,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.username
                        ? _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploaded-documents", {
                                attrs: {
                                  username: _vm.username,
                                  documents: _vm.documents,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("client-profile-campaigns", {
                            attrs: { "client-profile-id": _vm.clientProfileId },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("client-profile-lists", {
                            attrs: { "client-profile-id": _vm.clientProfileId },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg col-12" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("actions-panel", {
                            attrs: {
                              loading: _vm.loading,
                              "client-profile-id": _vm.clientProfileId,
                              profile: _vm.profile,
                              applications: _vm.applications,
                              username: _vm.username,
                              "tab-data": _vm.tabData,
                              "current-tab": _vm.currentTab,
                              "board-id": _vm.boardId,
                            },
                            on: {
                              tab: _vm.changeAction,
                              submit: _vm.loadChangelog,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("timeline-container", {
                        attrs: {
                          profile: _vm.profile,
                          "client-profile-id": _vm.clientProfileId,
                          "board-id": _vm.boardId,
                          "loading-changelog": _vm.loadingChangelog,
                          "loading-more-timeline": _vm.loadingMoreTimeline,
                          "timeline-tab": _vm.timelineTab,
                          "client-username": _vm.username,
                          applications: _vm.applications,
                          limit: _vm.limit,
                          offset: _vm.offset,
                        },
                        on: {
                          "update:timelineTab": function ($event) {
                            _vm.timelineTab = $event
                          },
                          "update:timeline-tab": function ($event) {
                            _vm.timelineTab = $event
                          },
                          "change-action": _vm.changeAction,
                        },
                      }),
                      _vm._v(" "),
                      _c("manage-referrer-modal", {
                        ref: "referrersModal",
                        attrs: {
                          submitting: _vm.submittingReferrer,
                          "referrer-value": _vm.selectedReferrer,
                        },
                        on: { submit: _vm.handleReferrerSubmit },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("inactive-profile-bar", {
        attrs: { "client-profile-id": _vm.clientProfileId },
        on: { show: _vm.showActiveToggleModal },
      }),
      _vm._v(" "),
      _c("duplicate-client-profile-modal", {
        ref: "duplicateModal",
        attrs: {
          loading: _vm.duplicatingClientProfile,
          "application-id": _vm.currentApplicationIdForDuplication,
          pin: _vm.duplicateAndPin,
          "client-profile-details": Object.assign({}, _vm.profile, {
            id: _vm.clientProfileId,
          }),
        },
        on: {
          submit: _vm.handleDuplicateClientProfile,
          hidden: _vm.resetDuplicateProfileModalData,
        },
      }),
      _vm._v(" "),
      _c("merge-client-profile-modal", {
        ref: "mergeModal",
        attrs: {
          "board-id": _vm.boardIdToUse,
          loading: _vm.mergingClientProfile,
          "client-profile-origin": Object.assign({}, _vm.profile, {
            id: _vm.clientProfileId,
          }),
        },
        on: { submit: _vm.handleMergeClientProfile },
      }),
      _vm._v(" "),
      _c("active-toggle-modal", {
        ref: "activeToggleModal",
        attrs: {
          "client-profile-id": _vm.clientProfileId,
          "is-active": _vm.profile.active,
        },
      }),
      _vm._v(" "),
      _c("client-profile-master-unsubscribe-confirmation", {
        ref: "masterUnsubscribeModal",
        attrs: {
          "client-profile-id": _vm.clientProfileId,
          "unsubscribe-author": _vm.profile.authorUnsubscribed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }